
export const all_routes = {

    //Home Module (Single Homepage)
    homeone: "/",

    //Course Modules
    masterclass: "/masterclass",
    ebooks: "/ebooks",
    ebookDetail: "/ebooks/:slug",
    ebookRead: "/ebooks/:id/read",
    studentEbooks: "/student/student-ebooks",
    courseGrid: "/course/course-grid",
    courseList: "/course/course-list",
    courseDetails: "/course/course-details",
    courseDetails2: "/course/course-details-2",
    courseCategory: "/course/course-category",
    courseCategory2: "/course/course-category-2",
    courseCategory3: "/course/course-category-3",
    courseResume: "/course/course-resume",
    courseWatch: "/course/course-watch",
    courseCart: "/course/cart",
    courseCheckout: "/course/checkout",
    addNewCourse: "/course/add-course",


    //Instructor Modules
    instructorDashboard: '/instructor/instructor-dashboard',
    instructorProfile: '/instructor/instructor-profile',
    instructorCourse: '/instructor/instructor-course',
    instructorCourseGrid: '/instructor/instructor-course-grid',
    instructorAnnouncements: '/instructor/instructor-announcements',
    instructorAssignment: '/instructor/instructor-assignment',
    instructorQuiz: '/instructor/instructor-quiz',
    instructorQuizResult: '/instructor/instructor-quiz-results',
    instructorCertificate: '/instructor/instructor-certificate',
    instructorEarning: '/instructor/instructor-earnings',
    instructorStatements: '/instructor/instructor-statements',
    instructorMessage: '/instructor/instructor-message',
    instructorChangePassword: '/instructor/instructor-change-password',
    instructorPlan: '/instructor/instructor-plans',
    instructorSocialProfiles: '/instructor/instructor-social-profiles',
    instructorLinkedAccounts: '/instructor/instructor-linked-accounts',
    instructorNotification: '/instructor/instructor-notifications',
    instructorIntegrations: '/instructor/instructor-integrations',
    instructorWithdraw: '/instructor/instructor-withdraw',
    instructorWishlist: '/instructor/instructor-wishlist',
    instructorReviews: '/instructor/instructor-reviews',
    instructorQuizAttempts: '/instructor/instructor-quiz-attempts',
    instructorOrders: '/instructor/instructor-orders',
    instructorChat: '/instructor/instructor-chat',
    instructorReferral: '/instructor/instructor-referral',
    instructorTickets: '/instructor/instructor-tickets',
    instructorQA: '/instructor/instructor-quiz-questions',
    instructorsettings: '/instructor/instructor-settings',
    instructorPayout: '/instructor/instructor-payout',
    instructorCourseManage: '/instructor/course-manage',




    studentDashboard: '/student/student-dashboard',
    studentProfile: '/student/student-profile',
    studentsGrid: '/instructor/students',
    studentsDetails: '/instructor/students-details',
    studentsList: '/instructor/student-list',
    studentOrderHistory: '/student/student-order-history',
    studentMessage: '/student/student-messages',
    studentCourses: '/student/student-courses',
    studentCertificates: '/student/student-certificates',
    studentReviews: '/student/student-reviews',
    studentWishlist: '/student/student-wishlist',
    studentQuiz: '/student/student-quiz',
    studentQuizQuestion: '/student/student-quiz-questions',
    studentReferral: '/student/student-referral',
    studentTickets: '/student/student-tickets',
    studentSettings: '/student/student-settings',
    studentChangePassword: '/student/student-change-password',
    studentSocialProfile: '/student/student-social-profile',
    studentLinkedAccounts: '/student/student-linked-accounts',
    studentNotification: '/student/student-notifications',
    studentBillingAddress: '/student/student-billing-address',
    studentSubscription: '/student/student-subscription',
    studentAssignments: '/student/student-assignments',

    // Admin Routes
    adminDashboard: '/admin/dashboard',
    adminUsers: '/admin/users',
    adminCourses: '/admin/courses',
    adminPendingCourses: '/admin/pending-courses',
    adminCategories: '/admin/categories',
    adminTransactions: '/admin/transactions',
    adminTickets: '/admin/tickets',
    adminSubscriptions: '/admin/subscriptions',
    adminAnalytics: '/admin/analytics',
    adminReports: '/admin/reports',
    adminSettings: '/admin/settings',
    adminCoupons: '/admin/coupons',

    cart: '/cart',
    login: '/login',
    register: '/register',
    verifyEmail: '/verify-email',
    forgotpassword: '/forgot-password',
    resetPassword: '/reset-password',
    setpassowrd: '/set-password',
    otp: '/otp',
    connect: '/connect',
    lockscreen: '/lock-screen',
    privacyPolicy: "/pages/privacy-policy",
    termsConditions: "/terms-conditions",
    contactUs: "/pages/contact-us",
    about_us: "/pages/about-us",
    invoices: "/pages/invoices",
    FAQ: "/pages/faq",
    pricingPlan: "/pages/pricing-plan",
    Error404: "/pages/error-404",
    Error500: "/pages/error-500",
    underconstruction: "/pages/under-construction",
    comingSoon: "/pages/coming-soon",
    becomeAnInstructor: "/pages/become-an-instructor",
    instructorList: '/pages/instructor-list',
    instructorGrid: '/pages/instructor-grid',
    instructorDetails: '/pages/instructor-details',
    notification: '/pages/notifications',
    testimonials: '/pages/testimonials',



    blogGrid: "/blog/blog-grid",
    blogGrid2: "/blog/blog-2-grid",
    blogGrid3: "/blog/blog-3-grid",
    blogDetails: "/blog/blog-details",
    blogCarousal: "/blog/blog-carousal",
    blogMasonry: "/blog/blog-masonry",
    blogLeftSidebar: "/blog/blog-left-sidebar",
    blogRightSidebar: "/blog/blog-right-sidebar",
    blogDetailsLeftSidebar: "/blog/blog-details-left-sidebar",
    blogDetailsRightSidebar: "/blog/blog-details-right-sidebar",

    // Payment
    paymentCallback: '/payment/callback',

    // Community
    community: '/community',
    communityPost: '/community/:postId',
    // Canonical post-detail URL (used by notifications + shared links). Kept as an
    // alias alongside communityPost so both /community/:id and /community/posts/:id resolve.
    communityPostDetail: '/community/posts/:postId',

};
